export default "__VITE_ASSET__BzrkvJSO__$_?url__"